import "./index.css";
import { AppHeader } from "./AppHeader";
import type { ReactNode } from "react";

type IProps = {
  children: ReactNode;
};

export const AppLayout = ({ children }: IProps) => {
  return (
    <>
      <AppHeader />
      <div className="app-layout__content">{children}</div>
    </>
  );
};
